import { Link } from "react-router-dom";
import { ArrowRight, MapPinned } from "lucide-react";
import { Button } from "@/components/ui/button";

export const MapsUpgradeCard = ({ className = "", testId = "maps-upgrade-card" }) => (
  <div className={`relative flex flex-col items-start justify-end overflow-hidden rounded-xl border border-slate-200 bg-slate-900 p-6 ${className}`} data-testid={testId}>
    <svg className="absolute inset-0 h-full w-full opacity-30" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0 40 Q30 35 50 50 T100 45" stroke="#334155" strokeWidth="3" fill="none" />
      <path d="M30 0 Q35 40 25 100" stroke="#334155" strokeWidth="2" fill="none" />
      <path d="M70 0 Q60 50 75 100" stroke="#334155" strokeWidth="2" fill="none" />
      {[[22, 30], [55, 35], [45, 70], [78, 28]].map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r="2.2" fill="#3b82f6" />)}
    </svg>
    <span className="relative flex h-11 w-11 items-center justify-center rounded-lg bg-blue-600 text-white"><MapPinned className="h-5 w-5" /></span>
    <h3 className="font-display relative mt-4 text-lg font-bold text-white">Maps are on higher plans</h3>
    <p className="relative mt-1 max-w-sm text-sm text-slate-300">See every address on a live map, coloured by locksmith or status, with the current job pulsing. Upgrade your plan to switch maps on.</p>
    <Button asChild className="relative mt-5 bg-blue-600 hover:bg-blue-500" data-testid={`${testId}-billing-link`}>
      <Link to="/manager/billing">See plans <ArrowRight className="ml-1 h-4 w-4" /></Link>
    </Button>
  </div>
);
